import JSZip from "jszip";

interface Data {
    [index: string]: {
        filePath: string
        filename: string
    }[]
}

const prefix = "https://cdn.amegroups.cn"
const imageSuffix = ['jpg', 'png', 'webp', 'bmp', 'gif', 'tiff']

const fetchData = (item: any): Promise<Blob> => {
    let suffix = "?timeStamp=" + new Date().getTime()
    let formatFrom = item.filePath.split('.').pop()
    let formatTo = item.filename.split('.').pop()
    if (formatFrom !== formatTo && imageSuffix.includes(formatFrom) && imageSuffix.includes(formatTo)) {
        suffix += "&x-oss-process=image/format," + formatTo
    }
    return  fetch(prefix + item.filePath + suffix).then(res => res.blob())
}

const saveAs = (content: Blob, fileName: string) => {
    let objectURL = window.URL.createObjectURL(content)
    const link = document.createElement('a')
    link.href = window.URL.createObjectURL(content)
    link.download = fileName
    link.click()
    window.URL.revokeObjectURL(objectURL)
}

const downloadImageZip = (data: Data, zipName: string) => {
    let zip = new JSZip()
    console.log(zipName)
    Object.keys(data).forEach((name) => {
        let jpgZip = zip.folder(zipName)
        data[name].forEach(item => {
            jpgZip?.file(item.filename, fetchData(item))
        })
    })
    let progressBar = document.querySelector('#progress-bar')! as HTMLDivElement
    progressBar.parentElement.style.display = 'block'
    zip.generateAsync({type: 'blob'}, (metadata) => {
        // let msg = "progression: " + metadata.percent.toFixed(2) + "%"
        // if (metadata.currentFile) {
        //     msg += ", current file = " + metadata.currentFile
        // }
        // console.log(msg)
        progressBar.style.width = metadata.percent + "%"
    }).then((content) => {
        saveAs(content, zipName + '.zip')
        progressBar.parentElement.style.display = 'none';
        (document.querySelector('#packaging') as HTMLButtonElement).disabled = false
    })
}

const main = () => {
    let btnEle = document.querySelector('#packaging') as HTMLButtonElement
    btnEle.disabled = true
    let issueId = (document.querySelector('input[name=issueId]') as HTMLInputElement).value
    let year = (document.querySelector('input[name=year]') as HTMLInputElement).value
    let flag = (document.querySelector('select[name=flag]') as HTMLSelectElement).selectedOptions[0].value
    let params = {issueId: issueId, year: year, flag: flag}
    let zipName = btnEle.getAttribute('data-title') + '-' + flag + '-' + (year ? year : issueId)
    fetch('/editor/downloadZip',
        {method: 'POST', mode: 'cors', body: new URLSearchParams(params)})
        .then(res => res.json())
        .then(data => downloadImageZip(data, zipName))
}

document.addEventListener('readystatechange', () => {
    if (document.readyState === 'interactive') {
        document.querySelector('.action-issuetoc #packaging')?.addEventListener('click', main)
    }
})